import React, { useEffect } from 'react'
import { AppUseDispatch, AppUseSelector } from '../../redux/hooks'
import { getAllLanguage, getWordsList } from '../../redux/actions/onboardingAction'
import { RESET_ONBOARDING, SET_ALL_WORDS, SET_LANGUAGE_INFO, SET_STEPPER_STEP } from '../../redux/types'
import HeaderOld from 'containers/header-old/HeaderOld'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
const getIcon = (lang: string) => {
  if (lang === 'Chinese') return '/images/language-icon-ch.png'
  if (lang === 'Korean') return '/images/language-icon-kr.png'
  if (lang === 'French') return '/images/language-icon-fr.png'

  return '/images/language-icon-ch.png'
}

const ChooseLanguage = () => {
  const { t } = useTranslation('onboarding')
  const dispatch = AppUseDispatch()
  const navigate = useNavigate()
  const onBoardingState = AppUseSelector(({ onboarding }) => onboarding)

  const handle = {
    selectLanguage: async (languageData) => {
      languageData?.preferences?.forEach((preference, index) => (preference.is_active = index === 0 ? true : false))
      dispatch({ type: SET_LANGUAGE_INFO, payload: languageData })

      if (languageData?.preferences?.length < 1) {
        const response = await getWordsList({ language_id: languageData?._id })

        dispatch({ type: SET_ALL_WORDS, payload: { wordList: response?.data } })
      }
      dispatch({ type: SET_STEPPER_STEP, payload: 1 })
      navigate(`/learn-${languageData?.language?.toLowerCase()}/new`)
    },
    getAllLanguage: async () => {
      dispatch({ type: RESET_ONBOARDING })
      await getAllLanguage()
    },
  }

  useEffect(() => {
    handle.getAllLanguage()
  }, [])

  return (
    <>
      <HeaderOld />
      <div className='w-container'>
        <div className='common-padding-div mob-lr-padding'>
          <div className='choose-lunguage-main-div'>
            <div className='common-title-sec'>
              <h2 className='screen-common-title'>{t('chooseLanguage.title')}</h2>
            </div>
            <div className='survey-btn-main-div'>
              {onBoardingState?.languages?.map((languageInfo) => (
                <button
                  onClick={() => handle.selectLanguage(languageInfo)}
                  key={languageInfo?._id}
                  className={'lunguage-btn-cls btn'}
                >
                  <img
                    className='lunguage-img'
                    alt={t('common:iconAlt')}
                    //
                    src={getIcon(languageInfo?.language)}
                  />
                  {languageInfo?.language}
                </button>
              ))}
            </div>
            {/* <div className='text-center'>
              <button className='common-btn-cls outline-btn-class btn' disabled>
                View all languages
              </button>
            </div> */}
          </div>
        </div>
      </div>
    </>
  )
}

export default ChooseLanguage
